import { Router, Route, browserHistory, IndexRoute, IndexRedirect } from 'react-router';
import App from './components/App';

import Home from './components/Home';
import About from './components/About';

import Services from './components/Services/Index';
import NursingInsurance from './components/Services/NursingInsurance';
import Volunteering from './components/Services/Volunteering';
import DisabilitySupports from './components/Services/DisabilitySupports';

import Entry from './components/Entry';
import Recruit from './components/Recruit';
import NewsList from './components/NewsList';
import Single from './components/Single';
import Links from './components/Links';
import NotFound from './components/NotFound';

export default (
  <Router history={browserHistory}>
    <Route path="/" component={App}>

      <IndexRoute component={Home} />

      <Route path="/about" component={About} />

      <Route path="/services" component={Services}>
        <IndexRedirect to="/services/nursing-insurance" />
        <Route path="/services/nursing-insurance" component={NursingInsurance} />
        <Route path="/services/volunteering" component={Volunteering} />
        <Route path="/services/disability-supports" component={DisabilitySupports} />
      </Route>

      <Route path="/entry" component={Entry} />

      <Route path="/recruit" component={Recruit} />

      <Route path="/links" component={Links} />

      <Route path="/news" component={NewsList} />
      <Route path="/news/:news" component={Single} />

      <Route path="*" component={NotFound} />

    </Route>
  </Router>
);



/** WEBPACK FOOTER **
 ** ./src/Routes.js
 **/